import { setDefaults as o } from "./index90.mjs";
import { setI18n as r } from "./index89.mjs";
const p = {
  type: "3rdParty",
  init(t) {
    o(t.options.react), r(t);
  }
};
export {
  p as initReactI18next
};
